import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppThemeProvider } from './theme/AppThemeProvider';
import { PWAInstallProvider } from './context/PWAInstallContext';

// 1. Importa o React Query
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// 2. Instancia o cliente com as configurações padrão recomendadas
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // Evita refetch desnecessário ao mudar de aba no navegador
            retry: 1, // Se a API falhar (ex: 500), tenta só mais 1 vez antes de mostrar erro
            staleTime: 1000 * 60 * 5, // A cache dura 5 minutos antes de ser considerada "velha"
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // Envolvemos toda a aplicação com o provedor do React Query
    <QueryClientProvider client={queryClient}>
        <AppThemeProvider>
            <PWAInstallProvider>
                <App />
            </PWAInstallProvider>
        </AppThemeProvider>
    </QueryClientProvider>
);

// Service worker registrado no BOOT, nao dentro da tela de Home.
//
// O Chrome decide se o site e instalavel no CARREGAMENTO da pagina, e ter um service
// worker e um dos requisitos. Enquanto o registro morava no usePWAInstall (montado so
// depois do login), a primeira visita de alguem caia no login sem SW nenhum: o Chrome
// concluia "nao instalavel" e nao disparava `beforeinstallprompt`. Como o login navega
// por SPA, nao havia segundo carregamento naquela sessao para o evento ter nova chance
// — e o usuario nunca via o convite de instalar.
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').catch(() => {
            /* sem SW o app funciona igual, so nao fica instalavel */
        });
    });
}

// Log de performance (opcional)
reportWebVitals();
